import styled from "styled-components";

import { AppNotificationContainer } from "shared/components/organisms/AppNotification/styles";

interface INotificationsContainerProps {
  show: boolean;
}

export const NotificationsContainer = styled.div<INotificationsContainerProps>`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 99;
  transition: 0.3s all;

  padding-bottom: 2rem;

  overflow: hidden;

  background-color: ${({ theme }) =>
    theme.colors.globalTopbar.mobileNavigationBackground}87;

  backdrop-filter: blur(2px);

  ${({ show }) =>
    show ? "transform: translateY(0)" : "transform: translateY(100%)"};

  color: ${({ theme }) => theme.colors.globalTopbar.textColor};

  .gx-popover-scroll {
    margin: 0 auto;
  }

  ${AppNotificationContainer} {
    position: relative;
    top: 8rem;
    height: 100%;

    ul {
      max-height: calc(100vh - 240px);
    }
  }
`;
